import { connect } from "react-redux";
import { login, otpLogin, studentLoginOTP, codeLogin, loginValue, socialLogin } from "../actions";
import LoginComponent from "../components/login.jsx";
import { currentUser } from "../selectors";

const mapStateToProps = (state) => ({
  isLoading: state.auth.login.isLoading,
  errors: state.auth.login.errors,
  currentUser: currentUser(state),
});

export default connect(
  mapStateToProps,
  {
    login: login.request,
    codeLogin: codeLogin.request,
    otpLogin: otpLogin.request,
    studentLoginOTP: studentLoginOTP.request,
    loginValue: loginValue.request,
    socialLogin: socialLogin.request,
  },
)(LoginComponent);
